import { render, staticRenderFns } from "./NavigationSidebar.vue?vue&type=template&id=6a3e7feb&"
import script from "./NavigationSidebar.vue?vue&type=script&lang=js&"
export * from "./NavigationSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports